'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var Divider = require('@narvar/nth-bit-divider');
var nthKitDynamicLayoutNext = require('@narvar/nth-kit-dynamic-layout-next');
var useOrderTracking = require('@narvar/nth-hook-order-tracking');
var CarrierTrackingLink = require('@narvar/nth-block-carrier-tracking-link');
var TrackingEvents = require('./components/TrackingEvents.js');
var TrackingEventsList = require('./components/TrackingEventsList.js');
var TrackingEventDescription = require('./components/TrackingEventDescription.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var Divider__default = /*#__PURE__*/_interopDefaultLegacy(Divider);
var useOrderTracking__default = /*#__PURE__*/_interopDefaultLegacy(useOrderTracking);
var CarrierTrackingLink__default = /*#__PURE__*/_interopDefaultLegacy(CarrierTrackingLink);

const {
  FeatureLayout
} = nthKitDynamicLayoutNext.LayoutTree;
const ShippingActivity = _ref => {
  let {
    featureName,
    layout = FeatureLayout.PORTRAIT
  } = _ref;
  const {
    getCurrentShipment
  } = useOrderTracking__default["default"]();
  const currentShipment = getCurrentShipment();
  if (!currentShipment) return null;
  const {
    trackingNumber = ''
  } = currentShipment;
  return /*#__PURE__*/React__default["default"].createElement("div", {
    "data-test": "shippingHistoryContainer",
    "data-testid": "shippingHistoryContainer"
  }, layout === FeatureLayout.PORTRAIT && /*#__PURE__*/React__default["default"].createElement(Divider__default["default"], {
    featureName: featureName
  }), /*#__PURE__*/React__default["default"].createElement(TrackingEvents["default"], {
    featureName: featureName
  }), trackingNumber && /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(Divider__default["default"], {
    featureName: featureName
  }), /*#__PURE__*/React__default["default"].createElement(CarrierTrackingLink__default["default"], {
    featureName: featureName,
    layout: layout
  })));
};

exports.TrackingEventsList = TrackingEventsList["default"];
exports.TrackingEventDescription = TrackingEventDescription["default"];
exports["default"] = ShippingActivity;
